// SelectionLevel — the level segmented control (US-875 chrome · US-878 behavior).
//
// Square segmented control (Country / Provinces-States / Districts) wired through
// `useSelection`: changing the level re-points which hit layer map clicks query
// (the next click drills at that granularity) AND, via the borders-follow-level
// coupling, shows that tier's admin boundary lines. Presentational only — it is
// the inner control of the GeographicFocus block, which frames + labels it.
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import useSelection from "../../hooks/useSelection";

const LEVELS = [
  { value: "country", label: "Country" },
  { value: "provinces", label: "Provinces/States" },
  { value: "districts", label: "Districts" },
];

const SelectionLevel = () => {
  const { selectionLevel, setLevel } = useSelection();

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      size="small"
      value={selectionLevel}
      onChange={(_event, value) => value && setLevel(value)}
      aria-label="Selection level"
      sx={{
        "& .MuiToggleButton-root": {
          textTransform: "none",
          fontSize: 12,
          fontWeight: 500,
          py: 0.5,
          minHeight: 36,
          // Comfortable touch target on phones/tablets (coarse pointers).
          "@media (pointer: coarse)": { minHeight: 44 },
          color: "text.secondary",
          borderColor: "divider",
          "&.Mui-selected": {
            bgcolor: "primary.main",
            color: "primary.contrastText",
            "&:hover": { bgcolor: "primary.dark" },
          },
        },
      }}
    >
      {LEVELS.map((level) => (
        <ToggleButton key={level.value} value={level.value}>
          {level.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default SelectionLevel;
